import React from "react";
import Formfooter from "../Components/login/FormFooter";
import Signupform from "../Components/login/SignUpForm";

function Signup() {
  return (
    <>
      <title>Sign Up - Bajaj Finserv</title>
      <div className="login-page">
        <div className="login-content h-100">
          <div className="container h-100">
            <div className="row h-100">
              <div className="ipad-bottom m-auto">
                <Signupform />
                <Formfooter />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Signup;
